export default __webpack_public_path__ + "static/media/13602.1620279873.2c5c8a34-10ae-4018-805f-cbb43642a771.e58908fa.webp";